import styled from '@emotion/styled';
import { BaseTabPanel, BaseTabs, Stack, TabPanelContainer } from '@ui-components/neo.tax';

export const Container = styled(Stack)({
  width: 412,
  minWidth: 340,
});

export const BaseTabsStyled = styled(BaseTabs)({
  padding: '4px 16px 0 16px',
});

export const TabPanelContainerStyled = styled(TabPanelContainer)({
  flexBasis: '0',
  flexGrow: '1',
  overflowY: 'auto',
});

export const BaseTabPanelStyled = styled(BaseTabPanel)({
  display: 'flex',
  flexDirection: 'column',
});
